import {cloneDeep as _cloneDeep} from 'lodash';
import LandOwnershipsModel from "./../../models/LandOwnershipsModel"
const LandOwnershipsModule = {
    namespaced: true,
    state: () => ({
        landOwnerships: [],
        landOwnership: _cloneDeep(LandOwnershipsModel, true),
    }),
    getters: {
        getLandOwnerships (state) {
            return state.landOwnerships
        },
        getLandOwnership (state) {
            return state.landOwnership
        },
    },
    mutations: {
        setLandOwnerships (state, payload) {
            state.landOwnerships = payload
        },
        setLandOwnership (state, payload) {
            state.landOwnership = payload
        },
    },
    actions: {
        setLandOwnerships (context, payload) {
            context.commit('setLandOwnerships', payload);
        },
        setLandOwnership (context, payload) {
            context.commit('setLandOwnership', payload);
        },
    },

}

export default LandOwnershipsModule;
